<template>
  <div class="block">
    <div class="block-title left">
      <h3>Выберите карту:</h3>
    </div>
    <div class="choose-card string">
      <div class="fields three">
        <select v-model="selectedCard" :disabled="base.isEdit && !base.isRestart">
          <option v-for="(card, index) in user.cards" :key="index" :value="card">
            {{ card.mask }}
          </option>
          <option :value="null">Новая карта</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import chooseCardMixin from '@apps/order-form/src/mixins/chooseCard'

export default {
  name: 'ChoosePaymentCard',
  mixins: [chooseCardMixin],
}
</script>

<style lang="scss" scoped>
.choose-card {
  select {
    width: 100%;
    height: 35px;
    padding: 0 5px;

    color: #5d5d5d;

    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 3px;
    outline: 0;
  }
}

h3 {
  font-size: inherit;
}

.block {
  margin-top: 30px;

  &-title h3 {
    display: inline-flex;
    align-items: center;

    &.invalid-text {
      i {
        margin-right: 6px;

        font-size: 20px;
      }
    }
  }
}

.fields.three {
  @media (max-width: 768px) {
    grid-template-columns: 1fr !important;
  }
}

.fields {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
